// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Head from 'next/head';

// eslint-disable-next-line sonarjs/cognitive-complexity
const ImageSource = (props) => {
  const {
    srcSet = [],
    media,
    preloadImage,
    srcSetWithoutDPR = [],
    srcSetCart,
    fromBagPage,
  } = props;
  const [isSrcSetLoaded, setIsSrcSetLoaded] = useState(false);

  const sourceStrings = srcSet
    .map(({ density, url }) => {
      if (density) return `${url} ${density}`;
      return `${url}`;
    })
    .join(', ');

  const sourceStringsWithoutDPR =
    srcSetWithoutDPR.length > 0
      ? srcSetWithoutDPR
          .map(({ density, url }) => {
            if (density) return `${url} ${density}`;
            return `${url}`;
          })
          .join(', ')
      : '';

  const sourceStringsCart = fromBagPage
    ? srcSetCart
        .map(({ density, url }) => {
          if (density) return `${url} ${density}`;
          return `${url}`;
        })
        .join(', ')
    : '';

  const handleImageLoad = () => {
    setIsSrcSetLoaded(true);
  };

  const imagePreloadSrcset =
    preloadImage && !sourceStringsWithoutDPR && !fromBagPage ? (
      <Head>
        <link
          rel="preload"
          as="image"
          href={srcSet[0]?.url}
          imagesrcset={sourceStrings}
          media={media}
          key={srcSet[0]?.url}
        />
      </Head>
    ) : null;

  useEffect(() => {
    if (sourceStringsWithoutDPR || fromBagPage) {
      const img = new Image();
      img.srcset = sourceStrings;
      img.onload = handleImageLoad;
    }
  }, [sourceStrings, sourceStringsWithoutDPR, sourceStringsCart]);

  let srcStringValue;

  if (isSrcSetLoaded) {
    srcStringValue = sourceStrings;
  } else if (fromBagPage) {
    srcStringValue =
      (sourceStringsCart && sourceStringsCart.replace('.png', '.jpg')) || sourceStringsCart;
  } else if (sourceStringsWithoutDPR) {
    srcStringValue = sourceStringsWithoutDPR;
  } else {
    srcStringValue = sourceStrings;
  }

  return (
    <>
      {imagePreloadSrcset}
      <source srcSet={srcStringValue} media={media} />
    </>
  );
};

ImageSource.propTypes = {
  srcSet: PropTypes.arrayOf(PropTypes.shape({ density: PropTypes.string, url: PropTypes.string }))
    .isRequired,
  media: PropTypes.string.isRequired,
  preloadImage: PropTypes.bool,
  srcSetWithoutDPR: PropTypes.arrayOf(
    PropTypes.shape({ density: PropTypes.string, url: PropTypes.string })
  ),
  srcSetCart: PropTypes.arrayOf(
    PropTypes.shape({ density: PropTypes.string, url: PropTypes.string })
  ),
  fromBagPage: PropTypes.bool,
};

ImageSource.defaultProps = {
  preloadImage: false,
  srcSetWithoutDPR: [],
  srcSetCart: [],
  fromBagPage: false,
};

export default ImageSource;
